
import {
  actionCreator,
  API_URL,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrl,
  createSearchUrlForCustomAPI,
  extractDataFromObject,
  jsonApiHeader,
  showErrorMessage,
  showSuccessMessage,
  showWarningMessage,
} from '../../../actions/utilAction';

export {
  jsonApiHeader,
  actionCreator,
  checkHttpStatus,
  createSearchUrl,
  create_post_data,
  extractDataFromObject,
  createSearchUrlForCustomAPI,
  showWarningMessage,
  showErrorMessage,
  showSuccessMessage,
  API_URL,
};

export const CHANGE_PASSWORD_API = `${API_URL}/user/UpdateUserPassword`;
export const CHANGE_SUPERADMIN_PASSWORD_API = `${API_URL}/api/Organization/UpdateSuperadminUserPassword`;

export const changePasswordActionTypes = {
  post_changePassword: createRequestActionTypes('POST_CHANGEPASSWORD'),
  post_changeSuperadminPassword: createRequestActionTypes('POST_CHANGESUPERADMINPASSWORD'),
};




// WEBPACK FOOTER //
// ./src/components/changePassword/constants/ApiConstants.js